import 'core-js/stable';
import Vue from 'vue';
import App from './App.vue';
import {i18n, vuetify} from './plugins';
import router from './router';
import store from './store';

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App),
}).$mount('#app');
